/**
 * The white card used by sign-in, sign-up and the code screen.
 * Default: a navy band behind the card, logo inside it.
 * `plain`: no band, and a large logo above the card instead (sign-up).
 */
export default function AuthLayout({ children, onSubmit, wide = false, plain = false }) {
  return (
    <div className={`auth-page${plain ? ' auth-page-plain' : ''}`}>
      {plain && <div className="auth-brand auth-brand-outside"><img src="/logo.png" alt="SummitShield" width="332" height="80" /></div>}
      <form className={`auth-card${wide ? ' auth-card-wide' : ''}`} onSubmit={onSubmit} noValidate>
        {!plain && <div className="auth-brand"><img src="/logo.png" alt="SummitShield" width="166" height="40" /></div>}
        {children}
      </form>
    </div>
  );
}
